"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChannelMembers = void 0;
const react_1 = __importDefault(require("react"));
const stream_chat_react_1 = require("stream-chat-react");
const store_1 = require("@app/store");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useChannelMembers() {
    const { channel } = (0, stream_chat_react_1.useChatContext)();
    const me = (0, store_1.useRootSelector)((state) => state.me);
    return react_1.default.useState(() => {
        const asObject = channel?.state?.members;
        if (!asObject) {
            return [];
        }
        return Object.values(asObject)
            .map((m) => ({
            id: m.user_id,
            name: m.user?.name,
            // becaouse of Avatar component in EmployeeList
            email: m.user?.name,
            firstName: m.user?.name,
        }))
            .filter((m) => Boolean(m.id && m.name))
            .sort((member1, member2) => {
            if (member1.id === me.id) {
                return -1;
            }
            if (member2.id === me.id) {
                return 1;
            }
            if (!member1.name && !member2.name) {
                return 0;
            }
            if (!member1.name) {
                return 1;
            }
            if (!member2.name) {
                return -1;
            }
            return member1.name.localeCompare(member2.name);
        });
    });
}
exports.useChannelMembers = useChannelMembers;
